import { commonCurrencyListSelector } from 'src/store/commonPart/selector';
import { store } from 'src/store/store';
import { Enums } from 'src/models/enums';

/**
 * @returns string if symbol is found otherwise returns null
 */
export const getCurrencySymbolById = (key: number): string | null => {
  const hasData = commonCurrencyListSelector(store.getState())?.response;

  if (hasData) {
    const found = hasData.find(({ ID }) => ID === key);
    return found ? found.Symbol : null;
  }
  return null;
};

export const getCurrencyCodeById = (key: number): string | null => {
  const hasData = commonCurrencyListSelector(store.getState())?.response;

  if (hasData) {
    const found = hasData.find(({ ID }) => ID === key);
    return found ? found.code : null;
  }
  return null;
  // old
  // window.constants.currencies[key] ? window.constants.currencies[key].code.trim() : null;
};

/**
 * a formatter for currencies
 * taken from the old app
 */
export const formatCurrency = (
  value: number,
  digits = 2,
  decimalSeparator = undefined,
  groupSeparator = undefined
): string => {
  if (value == null || Number.isNaN(value)) {
    return '';
  }

  const n = value > 0 ? value : -value;
  const c = Number.isNaN(Math.abs(digits)) ? 2 : digits;
  const d = decimalSeparator === undefined ? '.' : decimalSeparator;
  const t = groupSeparator === undefined ? ',' : groupSeparator;
  const s = value < 0 ? '-' : '';
  const i = `${parseInt(Math.abs(+n || 0).toFixed(c), 10)}`;
  let j = i.length;
  j = j > 3 ? j % 3 : 0;

  return (
    s +
    (j ? i.substr(0, j) + t : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${t}`) +
    (c
      ? d +
        Math.abs(n - Number(i))
          .toFixed(c)
          .slice(2)
      : '')
  );
};

export const commonFormatCurrencyWithType = (
  amount: number | null,
  currencyType = 1,
  text = false,
  digits = 2
): string | null => {
  if (amount === null) {
    return null;
  }

  // MXN currency is restricted
  const preparedCurrencyType = currencyType === Enums.common.CurrencyTypeCode.MXN ? 1 : currencyType;

  const textValue = `${getCurrencySymbolById(preparedCurrencyType)}${formatCurrency(amount, digits)}`;
  return text ? textValue : textValue;
};
